export const MAPA_TABS = ['movimentacao', 'naturezaModalidade', 'custoCaptacao', 'custoIndexador', 'tirDuration'] as const;

export type MapaTab = typeof MAPA_TABS[number];

export const NATUREZA_MODALIDADE_MODES = ['mes', 'evolucao'] as const;

export type NaturezaModalidadeMode = typeof NATUREZA_MODALIDADE_MODES[number];

export interface MapaDaDividaUrlState {
  referenceDate: string | null;
  compareDate: string | null;
  visibleMonths: string[] | null;
  naturezaModalidadeMode: NaturezaModalidadeMode;
}

export const DEFAULT_MAPA_DA_DIVIDA_URL_STATE: MapaDaDividaUrlState = {
  referenceDate: null,
  compareDate: null,
  visibleMonths: null,
  naturezaModalidadeMode: 'mes',
};

export const LEGACY_MAPA_TAB_PARAM = 'mapaAba';
const REFERENCE_DATE_PARAM = 'mapaData';
const COMPARE_DATE_PARAM = 'mapaComparar';
const MONTHS_PARAM = 'mapaMeses';
const NATUREZA_MODALIDADE_MODE_PARAM = 'mapaNmModo';

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const isNaturezaModalidadeMode = (value: string | null): value is NaturezaModalidadeMode =>
  !!value && (NATUREZA_MODALIDADE_MODES as readonly string[]).includes(value);

const isIsoDate = (value: string | null): value is string => !!value && ISO_DATE_PATTERN.test(value);

const parseVisibleMonths = (value: string | null): string[] | null => {
  if (!value) return null;
  const months = Array.from(new Set(value.split(',').filter((month) => isIsoDate(month))));
  return months.length > 0 ? months : null;
};

export const parseMapaDaDividaUrlState = (params: URLSearchParams): MapaDaDividaUrlState => {
  const referenceDate = params.get(REFERENCE_DATE_PARAM);
  const compareDate = params.get(COMPARE_DATE_PARAM);
  const visibleMonths = params.get(MONTHS_PARAM);
  const naturezaModalidadeMode = params.get(NATUREZA_MODALIDADE_MODE_PARAM);
  return {
    referenceDate: isIsoDate(referenceDate) ? referenceDate : null,
    compareDate: isIsoDate(compareDate) ? compareDate : null,
    visibleMonths: parseVisibleMonths(visibleMonths),
    naturezaModalidadeMode: isNaturezaModalidadeMode(naturezaModalidadeMode)
      ? naturezaModalidadeMode
      : DEFAULT_MAPA_DA_DIVIDA_URL_STATE.naturezaModalidadeMode,
  };
};

export const writeMapaDaDividaUrlState = (
  current: URLSearchParams,
  next: Partial<MapaDaDividaUrlState>,
): URLSearchParams => {
  const merged = { ...parseMapaDaDividaUrlState(current), ...next };
  const params = new URLSearchParams(current);

  params.delete(LEGACY_MAPA_TAB_PARAM);

  if (merged.referenceDate) params.set(REFERENCE_DATE_PARAM, merged.referenceDate);
  else params.delete(REFERENCE_DATE_PARAM);

  if (merged.compareDate) params.set(COMPARE_DATE_PARAM, merged.compareDate);
  else params.delete(COMPARE_DATE_PARAM);

  if (merged.visibleMonths && merged.visibleMonths.length > 0) params.set(MONTHS_PARAM, merged.visibleMonths.join(','));
  else params.delete(MONTHS_PARAM);

  if (merged.naturezaModalidadeMode && merged.naturezaModalidadeMode !== DEFAULT_MAPA_DA_DIVIDA_URL_STATE.naturezaModalidadeMode) {
    params.set(NATUREZA_MODALIDADE_MODE_PARAM, merged.naturezaModalidadeMode);
  } else {
    params.delete(NATUREZA_MODALIDADE_MODE_PARAM);
  }

  return params;
};
